import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const reactPlugin = new ReactPlugin();

// Connection spot for shared Azure Application Insights resources.
// Prefer REACT_APP_APPINSIGHTS_CONNECTION_STRING for new resources; keep
// REACT_APP_APPINSIGHTS_KEY as a fallback for existing environments.
const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
        instrumentationKey: process.env.REACT_APP_APPINSIGHTS_KEY,
        extensions: [reactPlugin]
    }
});

appInsights.loadAppInsights();

export { reactPlugin, appInsights };
